type Segment = {
    label: string,
    value: number
}

const Pill = ({
    value,
    setValue,
    segments
}:{
    value: number
    setValue: Function
    segments: Segment[]
}) => {
    return <div className="pill-wrapper">
        {segments.map((s: Segment, i: number) => {
            let className = "";
            if(i === 0) className = "start";
            if(i === segments.length - 1) className = "end";
            return <div 
                key={i} 
                className={`segment ${className} ${value === s.value ? 'selected' : ''}`}
                onClick={() => setValue(s.value)}
            >
                {s.label}
            </div>
        })}
    </div>
}

export default Pill;